import {ActionMenuContentSectionRecentActivity} from '#/components/actionmenu/content/action-menu-content-section-recent-activity';
import {FunctionComponent} from 'react';

export const ActionMenuInformationActivityTab: FunctionComponent = () => {
  return (
    <>
      <ActionMenuContentSectionRecentActivity />
    </>
  );
};
